/**
 * ILIO SWIM — Theme JavaScript
 */
(function() {
  'use strict';

  function initAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-animate-delay');
          if (delay) {
            setTimeout(function() { entry.target.classList.add('is-visible'); }, parseInt(delay, 10));
          } else {
            entry.target.classList.add('is-visible');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-animate]').forEach(function(el) { observer.observe(el); });
  }

  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var scrollThreshold = 50;
    var ticking = false;
    function updateHeader() {
      if (window.scrollY > scrollThreshold) { header.classList.add('is-scrolled'); }
      else { header.classList.remove('is-scrolled'); }
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { window.requestAnimationFrame(updateHeader); ticking = true; }
    }, { passive: true });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function() { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    function closeMenu() { menu.classList.remove('is-open'); document.body.style.overflow = ''; }
    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeMenu); });
    menu.addEventListener('click', function(e) { if (e.target === menu) closeMenu(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu(); });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var toggles = document.querySelectorAll('[data-cart-toggle]');
    var closeBtn = document.querySelector('[data-cart-drawer-close]');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    if (!drawer) return;
    function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    toggles.forEach(function(btn) { btn.addEventListener('click', openDrawer); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }

  function refreshCartDrawer() {
    return fetch('/?sections=header-group,footer-group', { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      var html = sections['footer-group'] || sections['header-group'] || '';
      if (!html) {
        return fetch(window.location.pathname, { credentials: 'same-origin' }).then(function(r) { return r.text(); }).then(function(h) { replaceDrawerContent(h); });
      }
      replaceDrawerContent(html);
    })
    .catch(function() {
      fetch(window.location.pathname, { credentials: 'same-origin' }).then(function(r) { return r.text(); }).then(function(h) { replaceDrawerContent(h); });
    });
  }

  function replaceDrawerContent(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newBody = doc.querySelector('[data-cart-drawer-body]');
    var oldBody = document.querySelector('[data-cart-drawer-body]');
    if (newBody && oldBody) { oldBody.innerHTML = newBody.innerHTML; initCartChangeButtons(); }
  }

  function initCartChangeButtons() {
    document.querySelectorAll('[data-cart-change]').forEach(function(btn) {
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var line = parseInt(this.getAttribute('data-line'), 10);
        var quantity = parseInt(this.getAttribute('data-quantity'), 10);
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }), credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function() { updateCartCount(); refreshCartDrawer(); })
        .catch(function(err) { console.error('Cart change error:', err); });
      });
    });
  }

  function initSizeGuide() {
    var modal = document.querySelector('[data-size-guide-modal]');
    var toggle = document.querySelector('[data-size-guide-toggle]');
    var closeBtns = document.querySelectorAll('[data-size-guide-close]');
    if (!modal || !toggle) return;
    toggle.addEventListener('click', function() { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    function closeModal() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
  }

  function initProductGallery() {
    var mainImage = document.getElementById('ProductMainImage');
    var wrapper = document.querySelector('[data-gallery-wrapper]');
    var dataEl = document.querySelector('[data-product-images]');
    if (!mainImage || !wrapper || !dataEl) return;
    var images = JSON.parse(dataEl.textContent);
    var currentIndex = 0;
    var dots = wrapper.querySelectorAll('[data-dot-index]');
    var prevBtn = wrapper.querySelector('[data-gallery-prev]');
    var nextBtn = wrapper.querySelector('[data-gallery-next]');
    function goTo(idx) {
      currentIndex = (idx + images.length) % images.length;
      mainImage.src = images[currentIndex];
      dots.forEach(function(d, i) { d.classList.toggle('product-gallery__dot--active', i === currentIndex); });
    }
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });
    var startX = 0;
    wrapper.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    wrapper.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(currentIndex + (diff > 0 ? 1 : -1));
    }, { passive: true });
  }

  function initVariantSelector() {
    var sizeButtons = document.querySelectorAll('[data-option-value]');
    var variantInput = document.querySelector('[data-variant-id]');
    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    var productForm = document.querySelector('[data-product-form]');
    var variantDataEl = document.querySelector('[data-product-variants]');

    if (sizeButtons.length === 0 || !productForm || !variantDataEl) return;

    var variants = JSON.parse(variantDataEl.textContent);

    var optionGroups = {};
    document.querySelectorAll('[data-option-value]').forEach(function(b) {
      var i = b.getAttribute('data-option-index');
      if (b.classList.contains('product-form__size-btn--selected')) {
        optionGroups[i] = b.getAttribute('data-option-value');
      }
    });

    updateVariant();

    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.disabled) return;
        var index = this.getAttribute('data-option-index');
        var siblings = document.querySelectorAll('[data-option-index="' + index + '"]');
        siblings.forEach(function(s) { s.classList.remove('product-form__size-btn--selected'); });
        this.classList.add('product-form__size-btn--selected');
        optionGroups[index] = this.getAttribute('data-option-value');
        updateVariant();
      });
    });

    function updateVariant() {
      var matchedVariant = null;
      for (var v = 0; v < variants.length; v++) {
        var variant = variants[v];
        var match = true;
        for (var key in optionGroups) {
          var optionIndex = parseInt(key, 10);
          if (variant['option' + (optionIndex + 1)] !== optionGroups[key]) {
            match = false;
            break;
          }
        }
        if (match) { matchedVariant = variant; break; }
      }
      if (matchedVariant && variantInput) {
        variantInput.value = matchedVariant.id;
        if (addToCartBtn) { addToCartBtn.disabled = !matchedVariant.available; }
      }
    }
  }

  function initAddToCart() {
    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[data-add-to-cart]');
        if (!submitBtn || submitBtn.disabled) return;
        var originalText = submitBtn.textContent;
        submitBtn.textContent = '...';
        submitBtn.disabled = true;
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(response) { return response.json(); })
        .then(function() {
          updateCartCount();
          refreshCartDrawer().then(function() {
            var drawer = document.querySelector('[data-cart-drawer]');
            if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
          });
          submitBtn.textContent = '✓ Tilføjet!';
          setTimeout(function() { submitBtn.textContent = originalText; submitBtn.disabled = false; }, 2000);
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
    });
  }

  function initQuantitySelectors() {
    document.querySelectorAll('[data-quantity-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('[data-quantity-input]');
        if (input) { var val = parseInt(input.value, 10); if (val > 1) input.value = val - 1; }
      });
    });
    document.querySelectorAll('[data-quantity-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('[data-quantity-input]');
        if (input) { input.value = parseInt(input.value, 10) + 1; }
      });
    });
  }

  function initSortSelect() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  function initPredictiveSearch() {
    var toggles = document.querySelectorAll('[data-search-toggle]');
    var overlay = document.querySelector('[data-search-overlay]');
    var closeBtns = document.querySelectorAll('[data-search-close]');
    var input = document.querySelector('[data-search-input]');
    var resultsContainer = document.querySelector('[data-search-results]');
    if (!overlay || !input || !resultsContainer) return;
    var debounceTimer;
    function openSearch() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(function() { input.focus(); }, 100); }
    function closeSearch() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; input.value = ''; resultsContainer.innerHTML = ''; }
    toggles.forEach(function(btn) { btn.addEventListener('click', openSearch); });
    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeSearch); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch(); });
    input.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 1) { resultsContainer.innerHTML = ''; return; }
      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          if (products.length === 0) { resultsContainer.innerHTML = '<div class="search-overlay__empty">Ingen resultater fundet</div>'; return; }
          var html = '<div class="search-overlay__list">';
          products.forEach(function(product) {
            var imgSrc = product.image || product.featured_image && product.featured_image.url || '';
            var rawPrice = product.price ? parseFloat(product.price) : 0;
            var price = rawPrice ? (rawPrice % 1 === 0 ? rawPrice.toFixed(0) : rawPrice.toFixed(2)).replace('.', ',') + ' ' + (window.Shopify && Shopify.currency && Shopify.currency.active || 'DKK') : '';
            html += '<a href="' + product.url + '" class="search-overlay__item">';
            if (imgSrc) { html += '<div class="search-overlay__item-img"><img src="' + imgSrc + '" alt="' + (product.title || '') + '" loading="lazy"></div>'; }
            html += '<div class="search-overlay__item-info">';
            html += '<span class="search-overlay__item-title">' + product.title + '</span>';
            if (price) html += '<span class="search-overlay__item-price">' + price + '</span>';
            html += '</div></a>';
          });
          html += '</div>';
          html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="search-overlay__view-all">Se alle resultater &rarr;</a>';
          resultsContainer.innerHTML = html;
        })
        .catch(function() { resultsContainer.innerHTML = ''; });
      }, 250);
    });
  }

  function init() {
    initAnimations();
    initStickyHeader();
    initMobileMenu();
    initCartDrawer();
    initSizeGuide();
    initProductGallery();
    initVariantSelector();
    initAddToCart();
    initCartChangeButtons();
    initQuantitySelectors();
    initSortSelect();
    initPredictiveSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
